import React, { PureComponent, ChangeEvent, CSSProperties } from 'react'
import AssessmentEditableHeader from './AssessmentEditableHeader'
import { ButtonOLD } from '@lmc/ui-kit'

interface AssessmentTitleScreenProps {
  form: {
    name: string
  }
  onChange: (value: string) => void
  goToNextStep?: () => void
  style?: React.CSSProperties
  value?: string
}

interface AssessmentTitleScreenState {
  hasChangedName: boolean
}

export default class AssessmentTitleScreen extends PureComponent<
  AssessmentTitleScreenProps,
  AssessmentTitleScreenState
> {
  state: AssessmentTitleScreenState = {
    hasChangedName: false,
  }

  handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    if (!this.state.hasChangedName) {
      this.setState({ hasChangedName: true })
    }
    this.props.onChange(e.target.value)
  }

  render() {
    const { form, goToNextStep, onChange, style, value } = this.props

    if (!form || !onChange) return null

    const disabled = !this.state.hasChangedName || !value

    return (
      <div style={style}>
        <div style={styles.titleContainer as CSSProperties}>{TITLE}</div>
        <div style={styles.contentContainer}>
          <AssessmentEditableHeader
            // @ts-ignore
            form={form}
            onChange={this.handleChange}
            value={value || ''}
          />
          <div style={styles.note}>{NOTE(form.name)}</div>
          <ButtonOLD
            type="primary"
            disabled={disabled}
            onClick={goToNextStep}
            style={styles.nextButton}
          >
            Next Step
          </ButtonOLD>
        </div>
      </div>
    )
  }
}

const NOTE = (name: string) =>
  `By adding a custom title to a ${name}, you will be able to write an Assessment for any necessary Risk.`
const TITLE = 'Add a Custom Risk Assessment Title'

const styles = {
  button: {
    display: 'inline-block',
    float: 'right',
    marginTop: 24,
  },
  contentContainer: {
    marginTop: 64,
  },
  note: {
    marginTop: 24,
  },
  titleContainer: {
    fontWeight: 300,
    fontSize: 28,
    textAlign: 'center',
  },
  nextButton: {
    justifyContent: 'flex-end',
    marginTop: 5,
  },
}
